import React from "react";
import { Container, Row, Col, Nav, Image } from "react-bootstrap";
import Logo from "../assets/images/gkc-Logo_text.png";
import { FaTelegramPlane, FaFacebookF } from "react-icons/fa";
import { BsInstagram, BsTwitter, BsYoutube } from "react-icons/bs";
import { Link } from "react-router-dom";
import Whitepaperfile from "../assets/pdf/Whitepaper_GKC_Tech.pdf";
import { FaCloudDownloadAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <footer className="text-center">
        <section className="footer-top py-5">
          <Container>
            <Row>
              <Col xs={12}>
                <Image src={Logo} alt="Logo" className="img-fluid" />
                <p className="mt-4 fs-22 fw-700 font-outfit text-capitalize">
                  Join our community{" "}
                  <a
                    href="mailto:info@gkctech.io"
                    target="blank"
                    className="mt-4 fs-22 fw-400 font-outfit text-logan text-decoration-none text-lowercase"
                  >
                    info@gkctech.io
                  </a>
                </p>
              </Col>
              <Col xs={12}>
                <Nav className="justify-content-center">
                  <Link
                    className="nav-link"
                    target="blank"
                    to="https://t.me/gkctech"
                  >
                    <FaTelegramPlane className="text-logan" size={20} />
                  </Link>
                  <Link
                    className="nav-link"
                    target="blank"
                    to="https://www.facebook.com/people/GKC-Technologies/100092255200752/"
                  >
                    <FaFacebookF className="text-logan" size={20} />
                  </Link>
                  <Link
                    className="nav-link"
                    target="blank"
                    to="https://www.instagram.com/gkc_tech.io/"
                  >
                    <BsInstagram className="text-logan" size={20} />
                  </Link>
                  <Link
                    className="nav-link"
                    target="blank"
                    to="https://twitter.com/Gkctechio"
                  >
                    <BsTwitter className="text-logan" size={20} />
                  </Link>
                  <Link
                    className="nav-link"
                    target="blank"
                    to="https://www.youtube.com/@gkctechnologies"
                  >
                    <BsYoutube className="text-logan" size={20} />
                  </Link>
                </Nav>
              </Col>
              <Col
                xs={12}
                className="pt-4 d-flex justify-content-center align-items-center"
              >
                <a
                  className="text-decoration-none d-inline-block nav-link text-uppercase rounded-pill p-3 m-0"
                  href={Whitepaperfile}
                  download
                >
                  Whitepaper{" "}
                  <FaCloudDownloadAlt size={35} className="text-logan ms-2" />
                </a>
              </Col>
              <Col xs={12}>
                <Nav className="justify-content-center mt-3">
                  <p>📍 Head Office: GKC Tech24 Limited,4th Floor, Tirupati Enclave,
                        Ram Nagar, Nagpur-10 (MS) </p>
                </Nav>
                <Nav className="justify-content-center mt-3">
                  <p>📍 Overseas Office: GKC Tech24 L.L.C
                        The Meydan Hotel, Grandstand 6th Floor, Nad Al
                        Sheba, Dubai (U.A.E)</p>
                </Nav>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="footer-bottom py-5">
          <Container>
            <Row>
              <Col>
                <p className="m-0 fs-16 font-outfit fw-400 text-logan">
                  Global Knowledge Center | All rights reserved 2023
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </footer>
    </>
  );
};

export default Footer;
